import React, { useRef, useState, useEffect } from 'react';
import './ImageModal.css';

const ImageModal = ({
  isOpen,
  onClose,
  folder,
  imageName,
}) => {
  const modalRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [position, setPosition] = useState({ x: 50, y: 50 });
  const offset = useRef({ x: 0, y: 0 });

  useEffect(() => {
    if (isOpen) {
      const centerLeftX = (window.innerWidth / 4) - 200;
      const centerY = (window.innerHeight / 2);
      setPosition({ x: centerLeftX, y: centerY });
    }
  }, [isOpen]);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!isDragging) return;
      setPosition({
        x: e.clientX - offset.current.x,
        y: e.clientY - offset.current.y,
      });
    };

    const handleMouseUp = () => setIsDragging(false);
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging]);

  if (!isOpen || !imageName) return null;

  const srcBase = `/${folder}/${imageName.toLowerCase()}`;

  return (
    <div className="modal-backdrop">
        <div
            className="modal-wrapper"
            ref={modalRef}
            style={{
                position: 'absolute',
                top: position.y,
                left: position.x,
                backgroundColor: '#fff',
                border: '1px solid #ccc',
                boxShadow: '0 0 10px rgba(0,0,0,0.3)',
                padding: '10px',
                zIndex: 1000,
                maxWidth: '90vw',
                maxHeight: '90vh',
                overflow: 'auto',
                display: 'inline-block', // 👈 LET CONTENT define width
            }}
        >


        <div
          className="modal-header"
          style={{
            cursor: 'move',
            marginBottom: '10px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            fontWeight: 'bold',
          }}
          onMouseDown={(e) => {
            offset.current = {
              x: e.clientX - modalRef.current.offsetLeft,
              y: e.clientY - modalRef.current.offsetTop,
            };
            setIsDragging(true);
          }}
        >
          <span>{imageName}</span>
          <span
            className="modal-close"
            onClick={onClose}
            style={{
              cursor: 'pointer',
              marginLeft: '10px',
              fontSize: '20px',
            }}
          >
            ×
          </span>
        </div>
        <div className="modal-body">
        <img
  src={`${srcBase}.jpg`}
  alt={imageName}
  onError={(e) => {
    e.target.onerror = null;
    e.target.src = `${srcBase}.png`;
  }}
  style={{
    maxWidth: '100%',     // prevents overflow
    maxHeight: '80vh',    // caps height to viewport height
    display: 'block',
  }}
/>

        </div>
      </div>
    </div>
  );
};

export default ImageModal;
